import BaseResource from './index'

export default class UnionLocationConditionWorkResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/unionLocationConditionWork'
}
